export default "__VITE_ASSET__MeRN1Gpb__"